<template>
    <ModalFormCard :action="'/lead/' + lead.id" class="modal-default wide">
        <template #title>Delete lead</template>

        <template #default="{ saving, errors }">
            <div class="flex items-center justify-center pt-6">
                <div class="relative">
                    <IconAlert class="stroke-attention absolute -left-8 top-px" />
                    <p class="text-19 font-hero text-center">Warning</p>
                </div>
            </div>

            <p class="text-14 text-center pt-4 border-b border-grey-500 pb-10">
                You are about to permanently delete "{{ who }}"
            </p>

            <!-- <p class="mt-6 text-14 font-semibold">If you proceed, you will delete:</p>

            <template v-if="deleting != null">
                <p class="text-13 pt-1.5">- {{ deleting.deals || 0 }} Deal{{ deleting.deals != 1 ? 's' : '' }}</p>
                <p class="text-13 pt-1.5">- {{ deleting.phone_calls || 0 }} Phone call{{ deleting.phone_calls != 1 ? 's' : '' }}</p>
                <p class="text-13 pt-1.5">- {{ deleting.sms || 0 }} SMS message{{ deleting.sms != 1 ? 's' : '' }}</p>
                <p class="text-13 pt-1.5">- {{ deleting.notes || 0 }} Note{{ deleting.notes != 1 ? 's' : '' }}</p>
                <p class="text-13 pt-1.5">- {{ deleting.tasks || 0 }} Task{{ deleting.tasks != 1 ? 's' : '' }}</p>
                <p class="text-13 pt-1.5">- {{ deleting.appointments || 0 }} Appointment{{ deleting.appointments != 1 ? 's' : '' }}</p>
                <p class="text-13 pt-1.5">- {{ deleting.files || 0 }} File{{ deleting.files != 1 ? 's' : '' }}</p>
            </template> -->

            <p class="pb-1 mt-4 text-13 text-grey-900">
                Type '<span class="text-black">{{ test }}</span>' to delete your lead
            </p>

            <Input :placeholder="'Enter your lead\'s ' + type" class="" name="name" groupClass="bg-grey text-15" :canFoucs="false" />

            <input type="hidden" name="_method" value="delete" />

            <div class="modal-buttons">
                <ButtonSaving :disabled="saving" class="button-black default h-12">Delete lead</ButtonSaving>

                <div>
                    <button :disabled="saving" type="button" class="button-purple default" @click="$emit('close')">Cancel</button>
                </div>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Lead from '~/models/lead.js'
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    created() {
        // this.$axios.get('/actions/contact-before-delete/' + this.contact.id).then((res) => {
        //     this.deleting = res
        // })
    },

    data() {
        return {
            deleting: null,
        }
    },

    methods: {
    },

    computed: {
        lead() {
            return this.editingModel
        },

        who() {
            if (this.editingModel.first_name != '' && this.editingModel.first_name != null) {
                return (this.editingModel.first_name + ' ' + this.editingModel.last_name).trim()
            }

            return this.test
        },

        test() {
            return this.editingModel.phone_number != '' && this.editingModel.phone_number != null
                ? this.editingModel.phone_number.replace('+44', '0')
                : this.editingModel.email
        },

        type() {
            return this.test.indexOf('@') > -1 ? 'email' : 'phone number'
        }
    },
}
</script>
